import { render, staticRenderFns } from "./phmore.vue?vue&type=template&id=27a1b7ee"
import script from "./phmore.vue?vue&type=script&lang=js"
export * from "./phmore.vue?vue&type=script&lang=js"
import style0 from "./phmore.vue?vue&type=style&index=0&id=27a1b7ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports